import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export const startLti13ResourceSelection = (
  lmsCode,
  context_obj_id,
  connectedCourses,
  assessmentsOnly,
  readingLinksOnly,
  currentPage,
  contextSettings
) => {
  const root = createRoot(document.getElementById('lti13App'))
  root.render(
    <App
      lmsCode={lmsCode}
      contextObjId={context_obj_id}
      connectedCourses={connectedCourses}
      assessmentsOnly={assessmentsOnly}
      readingLinksOnly={readingLinksOnly}
      currentPage={currentPage}
      contextSettings={contextSettings}
    />
  )
}
